import React from "react";
import "./choose_objects_card.component.scss";
import Modal from "common_components/ui/modal/modal.ui";
import { Assets } from "utils/imports.utils";
import { ObjectTypes } from "utils/interface.utils";
import { STRINGS } from "constants/strings.constant";

interface IChooseObjectsCard{
    isOpen:boolean;
    onClose:() => void;
    onSelectedObject:(object:any) => void;
}

const OBJECT_ROWS = [
    { type: ObjectTypes.IMAGE, icon: Assets.choose_image, copy: STRINGS.chooseObject.image },
    { type: ObjectTypes.TEXT, icon: Assets.choose_text, copy: STRINGS.chooseObject.text },
    { type: ObjectTypes.BUTTON, icon: Assets.choose_button, copy: STRINGS.chooseObject.button },
    { type: ObjectTypes.VIDEO, icon: Assets.choose_video, copy: STRINGS.chooseObject.video },
    { type: ObjectTypes.SOCIAL, icon: Assets.choose_social, copy: STRINGS.chooseObject.social },
];

const ChooseObjectsCard = (props:IChooseObjectsCard) => {

    const onSelectedObjectFunction = (e:React.MouseEvent) => {
        props.onSelectedObject((e.target as HTMLElement).closest(".choose-objects-card-body-item")?.id)
    }

    return (
        <Modal isOpen={props.isOpen} onClose={props.onClose}>
            <div className="choose-objects-card">
                <div className="choose-objects-card-header">
                    <div>
                        <div className="choose-objects-card-header-title">{STRINGS.chooseObject.title}</div>
                        <div className="choose-objects-card-header-subtitle">{STRINGS.chooseObject.subtitle}</div>
                    </div>
                    <img className="choose-objects-card-header-close" src={Assets.close} alt={STRINGS.chooseObject.closeAlt} onClick={props.onClose}/>
                </div>
                <div className="choose-objects-card-body choose-objects-card-body-grid" onClick={onSelectedObjectFunction}>
                    {OBJECT_ROWS.map((row) => (
                        <div className={`choose-objects-card-body-item${row.type === ObjectTypes.SOCIAL ? " choose-objects-card-body-item-wide" : ""}`} id={row.type} key={row.type}>
                            <div className="choose-objects-card-body-item-tile">
                                <img className="choose-objects-card-body-item-icon" src={row.icon} alt=""/>
                            </div>
                            <div className="choose-objects-card-body-item-text">
                                <div className="choose-objects-card-body-item-title">{row.copy.name}</div>
                                <div className="choose-objects-card-body-item-description">{row.copy.description}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    )
}

export default ChooseObjectsCard;
